<div id="certificate" #certificate>

  @if (document.content.duplicateCertificateNumber) {
    <section id="duplicate-info">
      <p>Lõputunnistuse nr. {{document.content.duplicateCertificateNumber}}</p>
      <p>duplikaat {{document.content.duplicateIssueDate }}</p>
    </section>
  }

  <img alt="Eesti vapp" src="../../../assets/img/vapp.svg" id="coat-of-arms">

  <h1 id="certificate-title">{{ document.content.documentName.toUpperCase() }}</h1>

  @if (document.type === 'GRADUATION_DOCUMENT_TYPE:BASIC_EDUCATION_CERTIFICATE' || document.type === 'GRADUATION_DOCUMENT_TYPE:GENERAL_EDUCATION_CERTIFICATE') {
    <p>{{ document.content.registrationNumber }}</p>
    <section id="info">
      @if (document.status === 'CERT_DOCUMENT_STATUS:INVALID') {
        <p class="info-badge">Kehtetu</p>
      }
    </section>
    <section id="graduate">
      <p class="bold">{{ document.content.graduate.firstName }} {{ document.content.graduate.lastName }}</p>
      <p>(ees- ja perekonnanimi)</p>
    </section>
    <section id="identity">
      <p class="bold">
        {{ document.content.graduate.idCode | idCode }}
        @if (!document.content.graduate.idCode && document.content.graduate.dateOfBirth) {
          {{ document.content.graduate.dateOfBirth | date: 'dd.MM.yyyy' }}
        }
      </p>
      <p>
        @if (document.content.graduate.idCode) {
          (isikukood)
        }
        @if (!document.content.graduate.idCode && document.content.graduate.dateOfBirth) {
          (sünnikuupäev)
        }
      </p>
    </section>
    <p>on lõpetanud</p>
    <section id="institution">
      <p class="bold">{{ document.content.educationalInstitution.locationToPrintout }}</p>
      <p class="bold">{{ document.content.educationalInstitution.nameToPrintOut }}</p>
      <p class="bold">{{ document.type === 'GRADUATION_DOCUMENT_TYPE:BASIC_EDUCATION_CERTIFICATE' ? document.content.studies.curriculumNameToPrintOut : document.content.studies.programme }}</p>
      <p class="bold">{{ document.content.studies.honors }}</p>
    </section>
    <p>õppenõukogu otsusega{{ document.content.councilDecision.registrationNumber !== 'XXX' ? ' nr ' + document.content.councilDecision.registrationNumber : '' }}</p>
    <p>{{ document.content.councilDecision.issueDateToPrintOut }}</p>
  }

</div>